<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 等不的title栏目 -->
        <div class="title_top">
            <div class="title_son" style="text-align:center;padding:30px 0">
                <div style="font-size:15px;color:#fff;font-weight:bold">{{housename}}</div>
                <div style="font-size:15px;color:#fff;font-weight:bold;padding-top:10px">余 额</div>
                <div style="font-size:30px;color:#fff;font-weight:bold;padding-top:10px"><span style="padding-right:5px;font-size:15px">￥</span>{{balance}}</div>
            </div>
        </div>
        <!-- <van-notice-bar  color="#1989fa" background="#ecf9ff" left-icon="info-o" @click="openHistoryrecharge">
            历史充值记录
        </van-notice-bar> -->
        <!--  -->
        <div style="padding-top:10px"></div>
        <van-col span='24' style="font-size:16px;font-weight:bold;padding-left:10px;padding-bottom:10px">充值金额：</van-col>
        <div style="padding:0 7px">
            <van-row gutter="20">
                <van-col span="8" style="text-align:center;margin-bottom:20px" v-for="(item,index) in list" :key="item">
                    <div class="sizeBut" :class="{active:currentIndex === index}" style="border-radius:6px;padding:20px 0;font-size:14px" @click="moneyClick(index,item)">{{item}}</div>
                </van-col>
            </van-row>
        </div>
        <!-- <van-field @input="oninput"  v-if="isShow" v-model="value" type="number" step='0.01' label="自定义金额：" placeholder="请输入金额(元)" /> -->
        <!-- <van-field v-if="isShow" v-model.number="value" type="number" step='0.01' label="自定义金额：" placeholder="请输入金额(元)" /> -->

        <van-field @input="oninput"  v-if="isShow" v-model="value" type="number" step='0.01' label="自定义金额：" placeholder="请输入金额(元)" />
        <!-- <van-col span='24' style="font-size:13px;color:#1989fa;padding-left:5%" @click="openHistoryrecharge">历史充值记录</van-col> -->
        <van-col style="margin-bottom:10px;padding:0px 10px;position: fixed;bottom:0;left:0;right:0;" v-show="hidshow">
            <van-button type="primary" @click="sureRechargrt" size="normal" block>确认充值</van-button>
        </van-col>

    </div>    
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data(){
        return{
            screenHeight: document.documentElement.clientHeight,//一个是实施的高度一个是手机整体的高度 底下判断监听
            originHeight: document.documentElement.clientHeight,
            hidshow:true,
            //
            appId:'',
            nonceStr:'',
            package:'',
            paySign:'',
            signType:'',
            timeStamp:'',
            houseguid:'',
            housename:'',
            balance:'',
            value1:'',
            smoeny:'',
            isShow:false,
            value:'',
            moeny:'',
            currentIndex:0,
            list:['100元','300元','500元','1000元','3000元','自定义']
        }
    },
    mounted(){
        let self = this;
        window.onresize = function() {
          return (function(){
              self.screenHeight = document.documentElement.clientHeight;
          })()
        }
    },
    watch:{
        screenHeight (val) {
          if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
              this.hidshow = false;
          }else if(this.originHeight == val ){
              this.hidshow = true
          }else{
              this.hidshow = true;
          }
      }
    },
    methods:{
        openHistoryrecharge(){
            this.$router.push({
                path:'/HistoricalRecharge'
            })
            // console.log(111)
            // let data={
            //     openId:VueCookie.get('openId'),
            //     pageNum:1,
            //     pageSize:10000
            // }
            // this.$postQuery('/FeePrepaidExpenses/getRechargeRecordList', data).then((response) => {
            //     console.log(response)
            // })
        },
        oninput(e){
            // e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            e.target.value = (e.target.value.replace(/[^\d]/g)) || null

            // console.log(e.target.value)
            this.value = e.target.value
            // this.value1 = e.target.value
        },
        moneyClick(index,item){
            this.currentIndex=index
            if(item=='自定义'){
                this.isShow = true
                this.moeny = item
            }else{
                this.isShow = false
                this.moeny = item
            }
        },
        sureRechargrt(){
            // console.log(this.moeny)
            if(!this.moeny){
                this.smoeny = 100
                this.RechargeClick()
            }else if(this.moeny=='100元'){
                this.smoeny = 100
                this.RechargeClick()
            }else if(this.moeny=='300元'){
                this.smoeny = 300
                this.RechargeClick()
            }else if(this.moeny=='500元'){
                this.smoeny = 500
                this.RechargeClick()
            }else if(this.moeny=='1000元'){
                this.smoeny = 1000
                this.RechargeClick()
            }else if(this.moeny=='3000元'){
                this.smoeny = 3000
                this.RechargeClick()
            }else if(this.moeny=='自定义'){
                if(!this.value){
                    this.$toast('请输入自定义金额')
                }else if(parseFloat(this.value)==0){
                    this.$toast('充值金额不能为0元')
                }else{
                    this.smoeny = parseFloat(this.value)
                    this.RechargeClick()
                }
            }
            // console.log(this.smoeny)
        },
        // 点击充值的接口
        RechargeClick(){
            console.log(this.smoeny)
            let data={
                houseguid:this.houseguid
            }
            this.$postQuery('/FeeRecord/getUnFeesTotal', data).then((response) => {
                console.log(response)
                if(parseFloat(response.data)==0){
                    this.payMoney()
                }else if(parseFloat(response.data)>0){
                    console.log(this.smoeny+parseFloat(this.balance))
                    if((this.smoeny+parseFloat(this.balance))>=parseFloat(response.data)){
                        this.$dialog.confirm({
                            message: '您存在未缴费账单（合计:'+response.data+' 元），本次充值将自动抵扣账单，确定要继续吗？',
                        }).then(() => {
                            this.payMoney()
                        }).catch(()=>{}); 
                    }else if((this.smoeny+parseFloat(this.balance))<parseFloat(response.data)){
                        this.payMoney()
                    }
                }
                // if(this.smoeny>=parseFloat(response.data)&&response.data!=0){
                //     this.$dialog.confirm({
                //         message: '您存在未缴费账单（合计:'+response.data+' 元），本次充值将自动抵扣账单，确定要继续吗？',
                //     }).then(() => {
                //         this.payMoney()
                //     }).catch(()=>{});
                // }else if(response.data==0||this.smoeny<parseFloat(response.data)){
                //     // console.log(111)
                //     this.payMoney()
                // }
            })
        },
        // 立即支付
        payMoney(){
            let data={
                houseguid:this.houseguid,
                openId:VueCookie.get('openId'),
                amount:this.smoeny,
                payReason:1
            }
            this.$postJson('/FeeRecord/createOrder', data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.appId=response.data.appId
                    this.nonceStr=response.data.nonceStr
                    this.package=response.data.package
                    this.paySign=response.data.paySign
                    this.signType=response.data.signType
                    this.timeStamp=response.data.timeStamp
                    var _this=this;
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', _this.imatePay(), false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', _this.imatePay());
                            document.attachEvent('onWeixinJSBridgeReady', _this.imatePay());
                        }
                    } else {
                        _this.imatePay()
                    }
                }

            })
            // console.log(data)

        },
        imatePay(){
            var _this=this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                appId:_this.appId,     //公众号ID，由商户传入     
                timeStamp:_this.timeStamp,     //时间戳，自1970年以来的秒数     
                nonceStr:_this.nonceStr,      //随机串     
                package:_this.package,
                signType:_this.signType,     //微信签名方式：
                paySign:_this.paySign, //微信签名 
            },
            function(res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // _this.$router.replace({
                    //     path:'/'
                    // })
                    window.location.href('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe95b8bf597bd4f05&redirect_uri=https%3A%2F%2Fpdxs.sdcskj.cn%2F%23%2F&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
                }else{
                    _this.$router.push('/')
                }
            })
        }
    },
    created(){
        this.balance = this.$route.query.balance
        console.log(this.balance,'111111')
        this.houseguid = this.$route.query.houseguid
        this.housename = this.$route.query.housename
    }
}
</script>

<style scoped>
.list{
    margin-top: 46px;
}
.www{
    border: 1px solid green;
}
.active{
    color:rgb(25, 137, 250) !important;
    background: linear-gradient(to right,#e6f0f6,#e6f0f6);
    /* border-color: green !important; */
    border: 0 !important;
}
.title_top{
    padding:7px;
}
.title_son{
    background-image: url('../../assets/Image/house-banner.png');
    background-repeat:no-repeat;
    background-position:center;
    background-size: auto 100%;
    border-radius: 4px;
}
.sizeBut{
    background-color: #f8f8f8e6;
    color: rgb(150, 146, 146);
    font-weight: bold;
}
</style>